export const createError = (msg) => new Error(msg);

export const createErrorIgnorePopup = (msg) => {
  const error = new Error(msg);
  error.ignore = true;
  return error;
};

export const createErrorWithMessageId = (messageId) => {
  const error = new Error();
  error.messageId = messageId;
  return error;
};
